import { KONFIRMASI_PENDAFTARAN, PELAKU_USAHA_TERSELEKSI, REGISTRASI } from "./registrasiTypes";

const initialState = {
    informasiPendaftaran: null,
    konfirmasiPendaftaran: {
        syaratKetentuan: null,
        logValidasi: null
    },
    paktaIntegritas: null,
    pelakuUsahaTerseleksi: {
        terdaftar: null,
        dataDiri: null,
        pic: null,
    }
};

const registrasiReducers = (state = initialState, action) => {
    let key, child, value;
    switch (action.type) {
        case REGISTRASI:
            ({ key, value } = action.payload);
            return {
                ...state,
                informasiPendaftaran: value,
            };
        case KONFIRMASI_PENDAFTARAN:
            ({ key, value } = action.payload);
            return {
                ...state,
                konfirmasiPendaftaran: {
                    ...state.konfirmasiPendaftaran,
                    [key]: value,
                }
            };
        case PELAKU_USAHA_TERSELEKSI:
            ({ key, child, value } = action.payload);
            if (child) {
                return {
                    ...state,
                    pelakuUsahaTerseleksi: {
                        ...state.pelakuUsahaTerseleksi,
                        [key]: {
                            ...[key],
                            [child]: value,
                        },
                    }
                };
            }
            return {
                ...state,
                pelakuUsahaTerseleksi: {
                    ...state.pelakuUsahaTerseleksi,
                    [key]: value,
                }
            };
        default:
            return state;
    }
};

export default registrasiReducers;